/**
 * Homepage-Only Engine Bundle: nbk-portfolio
 *
 * Everything in this file targets DOM that only exists on the front page
 * (the 3D cylindrical hero grid, the arc-cards carousel, the strategic
 * points slider, the Three.js dot-matrix background) — split into its own
 * entry so single-project.php / archive-project.php never download it.
 * See functions.php's nbk_enqueue_assets(): this bundle is only enqueued
 * when is_front_page() || is_home().
 *
 * Depends on `main` (registers gsap/ScrollTrigger and sets up
 * window.nbkLenis, which horizontal-points.js reads) — always enqueued
 * with `main` as a script dependency so it loads after it.
 *
 * Architecture: Nirajan <https://nbk.com.np>
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CurvedHeroGrid } from './curved-hero-grid.js';
import { HorizontalPointsSlider } from './horizontal-points.js';
import { DarkDotGridScene } from './canvas/dark-dot-grid-scene.js';
import { SpiralShowcase } from './spiral-showcase.js';
import { SpiralCosmicScene } from './canvas/spiral-cosmic-scene.js';
import { LightboxModal } from './lightbox-modal.js';
import { AboutWindowShowcase } from './about-window.js';

// Idempotent: main.js also registers this, but scripts can theoretically
// evaluate in either order, and gsap.registerPlugin() is safe to call
// more than once.
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  // 0. Interactive Lightbox Modal with Multi-Image Slider Engine
  window.nbkLightbox = new LightboxModal();

  // 1. 3D Curved Hero Grid & Continuous 3D Curved Scroll Engine
  new CurvedHeroGrid();

  // 2. Scroll-Pinned Horizontal Strategic Points Slider (arc-cards carousel)
  new HorizontalPointsSlider();

  // 4. Wholesome Three.js Interactive Animated Dot Matrix Grid for Dark
  // Backgrounds — the one dependency in this bundle that actually pulls
  // in Three.js, the single biggest reason this is split off from `main`.
  new DarkDotGridScene('dark-grid-canvas');

  // 5. Grok's Black Hole WebGL Cosmic Scene with White Mark (centered on More Work images)
  const cosmicScene = new SpiralCosmicScene('spiral-cosmic-canvas');

  // 6. 3D Helical Spiral Circular Showcase for "MORE WORK"
  new SpiralShowcase('spiral-showcase-wrapper', { cosmicScene });

  // 7. 3D Perspective Double-Door Architectural Window Showcase
  new AboutWindowShowcase();
});
